import axios from "../../utils/axios";

export const getBlogs = async (sort, filter) => {
    let queryString = "";

    if (sort === "newest") {
        queryString += "_sort=createdAt&_order=desc";
    }

    if (filter === "saved") {
        queryString += "&isSaved=true";
    }

    const response = await axios.get(`/blogs?${queryString}`);

    return response.data;
};
